import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPieChart03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11 2.796c0-.593 0-.889-.145-1.128a1.092 1.092 0 0 0-.563-.437c-.268-.082-.517-.018-1.016.109C4.518 2.552 1 6.865 1 12c0 6.075 4.925 11 11 11 1.435 0 2.806-.275 4.062-.774.479-.19.718-.286.886-.51.135-.178.217-.46.199-.684-.023-.279-.197-.518-.545-.997l-5.404-7.438A.996.996 0 0 1 11 12V2.796Z"
    />
    <path
      fill="currentColor"
      d="M21.204 13c.593 0 .889 0 1.128.145.19.117.372.349.437.563.082.268.018.517-.109 1.016a10.967 10.967 0 0 1-2.19 4.295c-.33.398-.495.596-.76.688a1.09 1.09 0 0 1-.712-.023c-.258-.108-.432-.348-.78-.828l-3.332-4.586c-.298-.41-.447-.615-.442-.786a.5.5 0 0 1 .193-.38c.136-.104.39-.104.896-.104h5.671ZM13 2.796c0-.593 0-.889.145-1.128.117-.191.349-.372.563-.437.268-.082.517-.018 1.016.109 3.886.99 6.946 4.05 7.936 7.936.127.499.19.748.109 1.016a1.093 1.093 0 0 1-.437.563c-.24.145-.535.145-1.128.145H13.8c-.28 0-.42 0-.527-.055a.5.5 0 0 1-.218-.218C13 10.62 13 10.48 13 10.2V2.796Z"
    />
  </svg>
);
SvgPieChart03.displayName = 'PieChart03';
export default SvgPieChart03;
